import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '../services/token.service';
import { Roles } from '../constants/roles';

export const CompanyGuard: CanActivateFn = () => {
  const tokenService = inject(TokenService);
  const router = inject(Router);

  const decoded = tokenService.decodeToken();
  if (decoded?.roles === Roles.Company) {
    return true;
  }

  router.navigate(['/Operation/unit']);
  return false;
};
